module.exports = __webpack_public_path__ + "img/insurance-responsibility.ae2c4a37.jpg";